import {
  faBars,
  faBox,
  faCaretUp,
  faCaretDown,
  faCheckCircle as faCheckCircleSolid,
  faChevronRight,
  faChevronLeft,
  faClock,
  faDesktop,
  faExclamationTriangle as faExclamationTriangleSolid,
  faFile,
  faFileAlt,
  faGift,
  faHome,
  faHorse,
  faMinus,
  faPause,
  faPlay,
  faPlus,
  faRandom,
  faSearch,
  faSignInAlt,
  faSpinner,
  faStop,
  faTimes,
  faUser,
  faBan,
  faUndo,
  faSquareFull,
  faSync,
  faComment as faCommentSolid,
  faCube,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFileAlt as faFileAltRegular,
  faCheckCircle as faCheckCircleRegular,
} from '@fortawesome/free-regular-svg-icons';
import {
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faAngleRight,
  faBox as faBoxRegular,
  faCheck,
  faChevronRight as faChevronRightRegular,
  faComment,
  faExclamationCircle,
  faGlobe,
  faHandPointer,
  faInfoCircle,
  faPaperPlane,
  faPlay as faPlayRegular,
  faSquare,
  faStop as faStopRegular,
  faThumbsUp,
  faWaveformPath,
  faWifiSlash,
  faBolt,
  faConveyorBeltAlt,
  faPencil as faPencilRegular,
  faMinus as farMinus,
  faPlus as farPlus,
  faTicketAlt as farTicketAlt,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowRight,
  faBox as lightBox,
  faCheckCircle,
  faQuestionCircle,
  faExclamationTriangle,
  faClock as lightClock,
  faTimesCircle,
  faAtomAlt,
  faExclamationCircle as faExclamationCircleLight,
  faPlusCircle as lightPlusCircle,
  faTimes as falTimes,
  faPlus as falPlus,
  faMinus as falMinus,
} from '@fortawesome/pro-light-svg-icons';
import { faUserHardHat, faPencil } from '@fortawesome/pro-solid-svg-icons';

export {
  faCommentSolid as commentSolid,
  faAngleRight as angleRight,
  faArrowUp as arrowUp,
  faArrowDown as arrowDown,
  faArrowLeft as arrowLeft,
  faArrowRight as arrowRight,
  faAtomAlt as atomAlt,
  faBars as bars,
  faBox as box,
  faBoxRegular as boxRegular,
  faCaretUp as caretUp,
  faCaretDown as caretDown,
  faCheckCircle as checkCircle,
  faCheckCircleSolid as checkCircleSolid,
  faChevronLeft as chevronLeft,
  faChevronRight as chevronRight,
  faChevronRightRegular as chevronRightRegular,
  faClock as clock,
  faDesktop as desktop,
  faCheck as check,
  faComment as comment,
  faCube as cube,
  faExclamationCircle as exclamationCircle,
  faFile as file,
  faFileAlt as fileAlt,
  faFileAltRegular as fileAltRegular,
  faCheckCircleRegular as checkCircleRegular,
  faGift as gift,
  faGlobe as globe,
  faHandPointer as handPointer,
  faHome as home,
  faHorse as horse,
  faInfoCircle as infoCircle,
  faMinus as minus,
  falMinus,
  farMinus,
  faPaperPlane as paperPlane,
  faPause as pause,
  faPencil as pencil,
  faPencilRegular as pencilRegular,
  faPlay as play,
  faPlayRegular as playRegular,
  faQuestionCircle as questionCircle,
  faRandom as random,
  faSearch as search,
  faSignInAlt as signIn,
  faSpinner as spinner,
  faSquare as square,
  faStop as stop,
  faStopRegular as stopRegular,
  faSync as sync,
  faConveyorBeltAlt as conveyorBeltAlt,
  faThumbsUp as thumbsUp,
  faTimes as times,
  faTimesCircle as timesCircle,
  faUser as user,
  faUserHardHat as userHardHat,
  faWaveformPath as waveformPath,
  faExclamationTriangle as exclamationTriangle,
  faExclamationTriangleSolid as exclamationTriangleSolid,
  faBan as ban,
  faUndo as undo,
  faPlus as plus,
  falPlus,
  farPlus,
  faSquareFull as squareFull,
  lightBox,
  lightClock,
  lightPlusCircle,
  faWifiSlash as wifiSlash,
  faBolt as bolt,
  faExclamationCircleLight as exclamationCircleLight,
  falTimes,
  farTicketAlt,
};
